module.exports = __webpack_public_path__ + "img/PT.a60bb34c.svg";